import React, { useState } from "react"
import { useOutletContext } from "react-router-dom"
import axios from "axios"
import { FaFilePdf, FaUpload, FaDownload } from "react-icons/fa"

export default function CircuitoRegulamentoPainel() {
  const { circuito } = useOutletContext()
  const circuitoId = circuito?._id

  const [arquivoPdf, setArquivoPdf] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleUpload = async () => {
    if (!arquivoPdf) return alert("Selecione um arquivo PDF primeiro.")
    
    setLoading(true)
    const formData = new FormData()
    formData.append("regulamentoPdf", arquivoPdf)

    try {
      const token = localStorage.getItem("token")
      await axios.put(`https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/regulamento-pdf`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      })
      alert("Regulamento atualizado com sucesso! Recarregue a página para ver a mudança.")
      setArquivoPdf(null)
    } catch (e) {
      alert("Erro ao atualizar o regulamento.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <div className="pc-page-header">
        <h1 className="pc-page-header__title">
          <FaFilePdf style={{ marginRight: 12, color: "var(--pc-accent)" }} />
          Regulamento Oficial
        </h1>
        <p className="pc-page-header__subtitle">Faça o upload do regulamento em PDF para os associados baixarem.</p>
      </div>

      <div className="pc-card" style={{ maxWidth: 600 }}>
        <div className="pc-card__header">
          <h3 className="pc-card__title">Atualizar Arquivo</h3>
        </div>

        <div style={{ padding: "20px 0" }}>
          {circuito?.regulamentoPdf && (
            <div style={{ marginBottom: 20, padding: 15, background: "rgba(16, 185, 129, 0.1)", border: "1px solid rgba(16, 185, 129, 0.3)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ color: "#10b981", fontWeight: "bold", display: "flex", alignItems: "center", gap: 8 }}>
                 <FaCheckCircle color="#10b981" /> PDF Atual Ativo
              </span>
              <a href={`https://api.ticketdovaqueiro.com/uploads/${circuito.regulamentoPdf}`} target="_blank" rel="noreferrer" className="pc-btn pc-btn--sm pc-btn--outline">
                <FaDownload /> Visualizar
              </a>
            </div>
          )}

          <div className="pc-form-group">
            <label className="pc-label">Selecione o novo arquivo (Apenas .pdf)</label>
            <input 
              type="file" 
              accept="application/pdf" 
              onChange={(e) => setArquivoPdf(e.target.files[0])} 
              className="pc-file-input" 
            />
          </div>

          <button onClick={handleUpload} disabled={loading || !arquivoPdf} className="pc-btn pc-btn--primary" style={{ width: "100%", marginTop: 10 }}>
            <FaUpload /> {loading ? "Enviando arquivo..." : "Salvar PDF"}
          </button>
        </div>
      </div>
    </div>
  )
}

// 💡 Pequeno hack para usar o ícone no bloco acima
function FaCheckCircle({ color }) {
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
}